
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/create",
      function () {
        return require("private-next-pages/organizations/create/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/create"])
      });
    }
  